import { Navigate } from "react-router-dom";
import StaticPagesHeader from "components/molecules/StaticPagesHeader";
import { SEO } from "utils/helmet/components/SEO";
import { getLocalStorageItem } from "utils/localStorage";
import url from "url/index";
import useTranslate from "hooks/useTranslate";
import { STORAGE_USER_COUNTRY, STORAGE_USER_IP } from "constants/variables";
import { makeLangUrl } from "helpers/makeLangUrl";
import { isCountryBlocked } from "utils/geoBlocking";

import GloryBackground from "assets/images/glory/403.png";
import BangerBackground from "assets/images/banger/not_available_banger.webp";

import "./styles.sass";

const NotAvailablePage = () => {
  const t = useTranslate();
  const currentCountry = getLocalStorageItem(STORAGE_USER_COUNTRY);
  const currentUserIP = getLocalStorageItem(STORAGE_USER_IP);
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  let backgroundImage;

  switch (VITE_APP_PROJECT_NAME) {
    case "glory":
      backgroundImage = GloryBackground;
      break;
    case "banger":
      backgroundImage = BangerBackground;
      break;
    default:
      backgroundImage = GloryBackground;
      break;
  }

  if (!isCountryBlocked(currentCountry, currentUserIP)) {
    return <Navigate to={makeLangUrl(url.routes.casino.index())} />;
  }

  return (
    <>
      <SEO
        pathname={`/${url.config.pages.root}/${url.config.pages.notAvailablePage}`}
      />
      <div className="NotAvailablePage">
        <StaticPagesHeader />
        <div className="NotAvailablePage__content">
          <img
            src={backgroundImage}
            alt="Not_available"
            className="NotAvailablePage__content_bg"
          />
          <div className="NotAvailablePage__content_header">
            {t("notavailable.header")}
          </div>
          <div className="NotAvailablePage__content_text">
            {t("notavailable.title")}
          </div>
        </div>
      </div>
    </>
  );
};

export default NotAvailablePage;
